import http from "../http";

const role = {
    /**
     * 获取所有角色信息列表，下拉框数据源
     */
    getRoleList() {
        return http.get(`/auth_resource/roleInfoController/queryRoleInfo`);
    },

    /**
     * 新增角色
     */
    addRole(model) {
        return http.post("/auth_resource/roleInfoController/addRoleInfo", model);
    },

    /**
     * 删除角色
     */
    delRole(model) {
        return http.post("/auth_resource/roleInfoController/deleteRoleInfo", model);
    },

    /**
     * 角色需要的权限
     */
    getRoleAuth() {
        return http.get("/auth_resource/menuinfo/getTreeMenuInfoList");
    },

    /**
     * 给角色添加权限
     */
    authRole(model) {
        return http.post("/auth_resource/roleInfoController/roleMenu", model);
    },

    /**
     * 获取部门列表
     * @param deptId
     */
    depList(id) {
        return http.get(`/auth_resource/organStrDict/organUser?deptId=${id}`);
    },

    /**
     * 用户组新增或修改
     */
    addEdit(model) {
        return http.post("/work_order/groupuser/addOrUpdate", model);
    },
    /**
     * 根据姓名查树用户
     * @param realName
     */
    searchUser(name) {
        return http.get(
            `/auth_resource/organStrDict/searchOrganUser?realName=${name}`
        );
    },
    /**
     * 根据用户组id获取用户组信息
     */
    getGroupDetail(id) {
        return http.get(`/work_order/groupuser/getUserByGroupId?id=${id}`);
    },
    /**
     * 获取所有用户
     * @returns
     */
    getAllUsers() {
        return http.get("/auth_resource/userInfo/getAllUserList");
    },
};
export default role;
